export const BLUR_DIGITAL_VALUES = 'blurDigitalValues'
export const BLUR_ASSET_NAMES = 'blurAssets'
export const SET_CURRENT_REPOSITORY = Symbol()
